import fr from "../locales/fr-CA";

const LOCALES = { "fr-CA": fr };
export const DEFAULT_LOCALE = "fr-CA";
export const SUPPORTED_LOCALES = ["fr-CA"];

export function getLocale() {
  return DEFAULT_LOCALE;
}

export function t(key, fallback) {
  const dict = LOCALES[getLocale()] || {};
  return key.split(".").reduce((acc, k) => (acc ? acc[k] : undefined), dict) ?? fallback ?? key;
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat(getLocale(), {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}
